import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';

export const COLORS = {
  primary: '#565BDF', // Action Blue
  primaryDark: '#2125AB', // Action Blue Dark
};

const theme = responsiveFontSizes(
  createTheme({
    palette: {
      primary: {
        main: COLORS.primary,
      },
    },
  }),
);

export default theme;
